import { render, staticRenderFns } from "./ApplicationForm.vue?vue&type=template&id=c6d95a72&scoped=true"
import script from "./ApplicationForm.vue?vue&type=script&lang=js"
export * from "./ApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./ApplicationForm.vue?vue&type=style&index=0&id=c6d95a72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d95a72",
  null
  
)

export default component.exports